import React from "react";
import StakingPageSection from "../sections/UserPageSection/Staking";
const StakingPage = () => {
  return <StakingPageSection />;
};

export default StakingPage;
